import {
  Button,
  Container,
  Divider,
  Grid,
  Link,
  Paper,
  Stack,
  Typography,
  Box,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import SocialMediaRoundedBtnGroup from "../../components/SocialMediaRoundedBtnGroup";
import Logo from "../../assets/namad-logo-removebg-preview.png";
import { Link as RouterLink } from "react-router-dom";
import InstagramImage from "../../assets/instagram.png";
import LinkedinImage from "../../assets/linkedin.png";
import TwitterImage from "../../assets/twitter.png";

interface FooterProps {
  dense?: boolean;
}

const FullFooter = () => {
  const { t } = useTranslation();
  return (
    <Paper
      elevation={0}
      sx={{ py: 2, borderRadius: 0, bgcolor: "background.default" }}
    >
      <Container>
        <Stack>
          <Paper elevation={0} sx={{ py: 4, bgcolor: "inherit" }}>
            <Grid container>
              <Grid item xs={12} sm={6} md={5} mx={"auto"}>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography
                      variant="h5"
                      component="h5"
                      sx={{ mb: 2 }}
                      textAlign="center"
                    >
                      {t("start_from_now")}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid
                      container
                      sx={{ display: "flex", justifyContent: "center" }}
                    >
                      <Grid item>
                        <Button
                          href="https://panel.parsianbit.com/signup"
                          variant="contained"
                          sx={{
                            width: "6.5rem",
                            px: 3.5,
                            py: 1.25,
                            mx: 1,
                            bgcolor: "#FF3DFF",
                            borderRadius: "50px",
                            color: "#341C63",
                            "&:hover": { bgcolor: "#FF3DFF" },
                          }}
                        >
                          {t("sign_up")}
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          href="https://panel.parsianbit.com/login"
                          variant="contained"
                          sx={{
                            width: "6.5rem",
                            px: 3.5,
                            py: 1.25,
                            mx: 1,
                            border: "1px solid #FF3DFF",
                            borderRadius: "50px",
                            "&:hover": { bgcolor: "#FF3DFF" },
                          }}
                        >
                          {t("sign_in")}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
          <Grid container>
            <Grid item xs={12} sm={12}>
              <Grid container>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  lg={3}
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  <h4>{t("about_us")}</h4>
                  <Link
                    to="/about-us"
                    component={RouterLink}
                    underline="none"
                    sx={{
                      display: "inline",
                      mb: 1,
                      color: "text.secondary",
                      "&:hover": { bgcolor: "background.darkBlue" },
                      bgcolor: "transparent",
                    }}
                    color="inherit"
                  >
                    {t("about_us")}
                  </Link>
                  <Link
                    to="/contact-us"
                    component={RouterLink}
                    underline="none"
                    sx={{
                      display: "inline",
                      mb: 1,
                      color: "text.secondary",
                      "&:hover": { bgcolor: "background.darkBlue" },
                      bgcolor: "transparent",
                    }}
                    color="inherit"
                  >
                    {t("contact_us")}
                  </Link>
                  <Link
                    component={RouterLink}
                    to="/terms"
                    underline="none"
                    sx={{
                      display: "inline",
                      mb: 1,
                      color: "text.secondary",
                      "&:hover": { bgcolor: "background.darkBlue" },
                    }}
                    color="inherit"
                  >
                    {t("terms")}
                  </Link>
                  <Link
                    to="/"
                    component={RouterLink}
                    underline="none"
                    sx={{
                      display: "inline",
                      mb: 1,
                      color: "text.secondary",
                      "&:hover": { bgcolor: "background.darkBlue" },
                      bgcolor: "transparent",
                    }}
                    color="inherit"
                  >
                    {t("information")}
                  </Link>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  lg={3}
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  <h4>{t("services")}</h4>
                  <Link
                    to="/"
                    component={RouterLink}
                    underline="none"
                    sx={{
                      display: "inline",
                      mb: 1,
                      color: "text.secondary",
                      "&:hover": { bgcolor: "background.darkBlue" },
                      bgcolor: "transparent",
                    }}
                    color="inherit"
                  >
                    {t("shop")}
                  </Link>
                  <Link
                    component={RouterLink}
                    to="/"
                    sx={{
                      display: "inline",
                      mb: 1,
                      color: "text.secondary",
                      "&:hover": { bgcolor: "background.darkBlue" },
                      bgcolor: "transparent",
                    }}
                    underline="none"
                    color="inherit"
                  >
                    {t("blog")}
                  </Link>
                  <Link
                    component={RouterLink}
                    to="/referral"
                    underline="none"
                    sx={{
                      display: "inline",
                      mb: 1,
                      color: "text.secondary",
                      "&:hover": { bgcolor: "background.darkBlue" },
                      bgcolor: "transparent",
                    }}
                    color="inherit"
                  >
                    {t("affiliate")}
                  </Link>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  lg={3}
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  <h4>{t("guide")}</h4>
                  <Link
                    component={RouterLink}
                    to="/faq"
                    underline="none"
                    sx={{
                      display: "inline",
                      mb: 1,
                      color: "text.secondary",
                      "&:hover": { bgcolor: "background.darkBlue" },
                      bgcolor: "transparent",
                    }}
                    color="inherit"
                  >
                    {t("faqs")}
                  </Link>
                  <Link
                    component={RouterLink}
                    to="/terms"
                    underline="none"
                    sx={{
                      display: "inline",
                      mb: 1,
                      color: "text.secondary",
                      "&:hover": { bgcolor: "background.darkBlue" },
                      bgcolor: "transparent",
                    }}
                    color="inherit"
                  >
                    {t("trade_terms")}
                  </Link>
                  <Link
                    component={RouterLink}
                    underline="none"
                    to="/user-level"
                    sx={{
                      display: "inline",
                      mb: 1,
                      color: "text.secondary",
                      "&:hover": { bgcolor: "background.darkBlue" },
                      bgcolor: "transparent",
                    }}
                    color="inherit"
                  >
                    {t("commission")}
                  </Link>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  lg={3}
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  <h4>{t("learn_more")}</h4>
                  <Link
                    component={RouterLink}
                    to="/buy/bitcoin"
                    underline="none"
                    sx={{
                      display: "inline",
                      mb: 1,
                      color: "text.secondary",
                      "&:hover": { bgcolor: "background.darkBlue" },
                      bgcolor: "transparent",
                    }}
                    color="inherit"
                  >
                    خرید بیت کوین
                  </Link>
                  <Link
                    component={RouterLink}
                    underline="none"
                    to="/buy/bitcoin"
                    sx={{
                      display: "inline",
                      mb: 1,
                      color: "text.secondary",
                      "&:hover": { bgcolor: "background.darkBlue" },
                      bgcolor: "transparent",
                    }}
                    color="inherit"
                  >
                    خرید اتریوم
                  </Link>
                  <Link
                    component={RouterLink}
                    underline="none"
                    to="/buy/bitcoin"
                    sx={{
                      display: "inline",
                      mb: 1,
                      color: "text.secondary",
                      "&:hover": { bgcolor: "background.darkBlue" },
                    }}
                    color="inherit"
                  >
                    خرید تتر
                  </Link>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Divider sx={{ mt: 5 }} />
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1}
            alignItems={"center"}
            justifyContent={"space-between"}
            mt={3}
          >
            <Box>
              <img src={Logo} alt="logo" width={80} height={80} />
            </Box>
            <Typography
              textAlign={{ xs: "start", sm: "center" }}
              component="p"
              sx={{ my: 1.5 }}
            >
              {" "}
              Parsianbit All Rights Reserved 2019 ©{" "}
            </Typography>
            <Stack direction={"row"} spacing={1.25} alignItems={"center"}>
              <Link href="/">
                <Box sx={{ width: "auto", height: "auto" }}>
                  <img
                    src={InstagramImage}
                    alt="icon market"
                    width="auto"
                    style={{ borderRadius: "10px" }}
                  />
                </Box>
              </Link>
              <Link href="/">
                <Box sx={{ width: "auto", height: "auto" }}>
                  <img
                    src={LinkedinImage}
                    alt="icon market"
                    width="auto"
                    style={{ borderRadius: "10px" }}
                  />
                </Box>
              </Link>
              <Link href="/">
                <Box sx={{ width: "auto", height: "auto" }}>
                  <img
                    src={TwitterImage}
                    alt="icon market"
                    width="auto"
                    style={{ borderRadius: "10px" }}
                  />
                </Box>
              </Link>
            </Stack>
          </Stack>
        </Stack>
      </Container>
    </Paper>
  );
};

const DenseFooter = () => {
  const { t } = useTranslation();

  return (
    <Paper elevation={0} sx={{ py: 2, borderRadius: 0, bgcolor: "#35003a" }}>
      <Container>
        <Grid container alignItems={"cetner"}>
          <Grid item xs={12} sm={6} sx={{ my: "auto" }}>
            {t("all_rights_reserved")}
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: "flex", justifyContent: "end" }}
          >
            <SocialMediaRoundedBtnGroup />
          </Grid>
        </Grid>
      </Container>
    </Paper>
  );
};
const Footer = (props: FooterProps) => {
  return props.dense ? <DenseFooter /> : <FullFooter />;
};

export default Footer;
